<div class="flex align-items-center mb-3">
  <span class="icon-bx-info-circle text-primary text-2xl mr-2"></span>

  <div class="font-bold text-xl">
    {{ data?.title }}
  </div>
</div>

<div class="flex flex-column align-items-center">
  <p class="text-color-secondary block mb-3">
    {{ data?.message }}
  </p>
</div>

<div
  class="flex mt-4 mb-2 align-self-stretch"
  [class.justify-content-between]="showContinueButton"
  [class.justify-content-end]="!showContinueButton"
>
  <button
    type="button"
    pButton
    pRipple
    class="p-button-secondary"
    (click)="onReturnToShipment()"
  >
    <span pButtonLabel>{{ secondaryButtonText }}</span>
  </button>

  @if (showContinueButton) {
    <button type="button" pButton pRipple (click)="onContinueWithoutOption()">
      <span pButtonLabel>{{ 'Continue Without ' + data?.option }}</span>
    </button>
  }
</div>
